/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_9f1416a2","_9f1416a2",""]'><div :class='["","_9f1416a2",""]'><cube-button @_click="showPicker" :class='["","_9f1416a2",""]'>multi-column-picker</cube-button><cube-picker-popup ref="__mpx_ref_picker__" title="多列选择器" :list="(dataList)" cancelTxt="取消" :selected-index="(selectedIndex)" confirmTxt="确认" @change='(e)=>__invoke(e, [["onChange"]])' @columnChange='(e)=>__invoke(e, [["onColumnChange"]])' :class='["","_9f1416a2",""]'/></div><div :class='["event-params","_9f1416a2",""]' v-if="(changeParams.length)"><div :class='["key","_9f1416a2",""]'>change 事件参数：</div><div :class='["value","_9f1416a2",""]'><div v-for="(item, index) in (changeParams)" :key="item.index" :class='["value-item","_9f1416a2",""]'><div :class='["item-key","_9f1416a2",""]'>{{item[0]}}</div><div :class='["item-value","_9f1416a2",""]'>{{item[1]}}</div></div></div><div :class='["key","_9f1416a2",""]'>columnChange 事件参数：</div><div :class='["value","_9f1416a2",""]'><div v-for="(item, index) in (columnChangeParams)" :key="item.index" :class='["value-item","_9f1416a2",""]'><div :class='["item-key","_9f1416a2",""]'>{{item[0]}}</div><div :class='["item-value","_9f1416a2",""]'>{{item[1]}}</div></div></div></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"scoped":true,"mid":"_9f1416a2"}'>
.event-params,
.demo-data
  margin-top: 10px
  padding: 10px 10px
  background-color: white
  border: 1px solid  white
  border-radius: 10px

.key
  margin-bottom: 10px
  font-size: 16px
.key-introduce
  margin-bottom: 10px
  line-height: 20px
.value
  margin-bottom: 20px
  white-space: break-spaces
  .value-item
    display flex
    justify-content: space-between
    height: 25px
    line-height: 25px
    font-size: 15px
    .item-value
      white-space nowrap
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_9f1416a2"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_9f1416a2"}
  /** script content **/
  require("./multi-picker.mpx.js?isComponent&outputPath=components%2Fmulti-picker9f1416a2%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./multi-picker.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fmulti-picker9f1416a2%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_9f1416a2"],
    ctorType: "component",
    outputPath: "components/multi-picker9f1416a2/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-picker-popup':getComponent(require("../../../packages/mpx-cube-ui/src/components/picker-popup/index.mpx?isComponent&outputPath=components%2Findex57353298%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>